module.exports = __webpack_public_path__ + "static/media/16UNODC26.20e36987.jpg";